import { Box, HStack, ListItem, Text, UnorderedList } from "@chakra-ui/layout";
import { FC, useCallback } from "react";

import { GhostButton, SolidButton } from "~/src/components/common/Button";
import { Modal } from "~/src/components/common/Modal";

type Props = {
  name: string | null;
  associatedAbtestGroupMessages: readonly string[];
  associatedPopupGroupMessages: readonly string[];
  associatedChatbotGroupMessages: readonly string[];
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
};

export const SourceDeleteConfirmDialog: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({
  name,
  associatedAbtestGroupMessages,
  associatedPopupGroupMessages,
  associatedChatbotGroupMessages,
  isOpen,
  onClose,
  onDelete,
}) => {
  const handleDelete = useCallback(() => {
    onDelete();
    onClose();
  }, [onClose, onDelete]);
  const hasAssociatedRecords =
    associatedAbtestGroupMessages.length > 0 ||
    associatedPopupGroupMessages.length > 0 ||
    associatedChatbotGroupMessages.length > 0;

  return (
    <Modal
      title={`「${name}」流入元を削除しますか？`}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Box mb="16px">
        {hasAssociatedRecords && (
          <>
            {associatedAbtestGroupMessages && (
              <UnorderedList>
                {associatedAbtestGroupMessages.map((message, index) => (
                  <ListItem key={index}>{message}</ListItem>
                ))}
              </UnorderedList>
            )}
            {associatedPopupGroupMessages && (
              <UnorderedList>
                {associatedPopupGroupMessages.map((message, index) => (
                  <ListItem key={index}>{message}</ListItem>
                ))}
              </UnorderedList>
            )}
            {associatedChatbotGroupMessages && (
              <UnorderedList>
                {associatedChatbotGroupMessages.map((message, index) => (
                  <ListItem key={index}>{message}</ListItem>
                ))}
              </UnorderedList>
            )}
          </>
        )}
        {!hasAssociatedRecords && <Text>関連するレコードはありません。</Text>}
      </Box>
      <HStack mt="16px" spacing="8px" justifyContent="flex-end">
        <GhostButton onClick={onClose}>戻る</GhostButton>
        <SolidButton onClick={handleDelete}>削除</SolidButton>
      </HStack>
    </Modal>
  );
};
